import { string, object } from 'yup';

const loginSchema = object().shape({
  username: string().email().required('The field email is required'),
  password: string().min(6).required('The field password is required'),
});

export default loginSchema;
